import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const IconNegativeFeedback = ({
  color = colors.inactiveHover,
  size = 12,
}: Pick<IProps, 'size' | 'color'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 5.99988C11.5 3.24321 9.25667 0.999878 6.5 0.999878C3.74278 0.999878 1.5 3.24266 1.5 5.99988"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 5.99988C11.5 8.76154 9.26167 10.9999 6.5 10.9999C3.73833 10.9999 1.5 8.76154 1.5 5.99988"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16356 4.75996C8.09456 4.75996 8.03856 4.81596 8.03906 4.88496C8.03906 4.95396 8.09506 5.00996 8.16406 5.00996C8.23306 5.00996 8.28906 4.95396 8.28906 4.88496C8.28906 4.81596 8.23306 4.75996 8.16356 4.75996"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.81981 4.75C4.75081 4.75 4.69481 4.806 4.69531 4.875C4.69531 4.944 4.75131 5 4.82031 5C4.88931 5 4.94531 4.944 4.94531 4.875C4.94531 4.806 4.88931 4.75 4.81981 4.75"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 7.99995C4.75 7.99995 5.4065 7.34395 6.5 7.34395C7.594 7.34395 8.25 7.99995 8.25 7.99995"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconNegativeFeedback;
